import { Loggable } from '@rbi-ctg/frontend';

/**
 * logger middleware can be used to run functions
 * on messages before they are logged to mparticle/logger
 */
export interface ILoggerMiddleware {
  <O extends Loggable>(attributes: { [key: string]: O }): { [key: string]: O };
}
